import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from './AuthContext'; // Импортируем AuthProvider
import { DateProvider } from './DateContext';
import { ProjectProvider } from './ProjectContext.js';
import Home from './components/Home.jsx';
import Logout from './components/Logout';
import Login from './components/Login';
import Navbar from './components/Navbar';  // Импорт Navbar
import Menu from './components/Menu.jsx';
import Dashboard from './components/Dashboard.jsx';
import QrCode from './components/QRcode.jsx';
import TariffDashboard from './components/admin/TariffDashboard.jsx';
import AdminDashboard from './components/admin/AdminDashboard.jsx';
import PaymentConstructor from './components/PaymentConstructor.jsx';
import CheckoutPage from './components/CheckoutPage.jsx';
import SuccessPage from './components/SuccessPage.jsx';
import ResetPasswordForm from './components/ResetPasswordForm.jsx';
import useServiceWorkerUpdater from './useServiceWorkerUpdater';

function App() {

  const { showReload, reloadPage } = useServiceWorkerUpdater(); 
  
  // App.jsx
console.log("Версия билда: 1.0.2");


  return (
    <ProjectProvider>
          <AuthProvider>
          <DateProvider>
              <div className='body' style={{ overflow: "hidden" }}>
                  <Router>
                    <Navbar/>
                    <Routes>   
                      <Route path="/" element={<Home/>} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/logout" element={<Logout />} />
                      <Route path='/Menu' element={<Menu />} />
                      <Route path="/qrcode" element={<QrCode/>} />
                      <Route path="/tarifeditor" element={<TariffDashboard/>} />
                      <Route path='/admin' element={<AdminDashboard/>} />
                      <Route path="/payment" element={<PaymentConstructor/>} />
                      <Route path="/checkout" element={<CheckoutPage/>} />
                      <Route path="/success" element={<SuccessPage/>} />
                      <Route path="/reset-password" element={<ResetPasswordForm />} />
                    </Routes>
                  </Router>
                  <ToastContainer
                        position="top-right"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                       {/* 🔄 Баннер для обновления */}
            {showReload && (
              <div style={{
                position: 'fixed',
                bottom: 0,
                width: '100%',
                backgroundColor: '#222',
                color: '#fff',
                padding: '12px',
                textAlign: 'center',
                zIndex: 1000,
              }}>
                Доступна новая версия сайта. <button onClick={reloadPage} style={{
                  marginLeft: '10px',
                  padding: '6px 12px',
                  backgroundColor: '#0d6efd',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}>Обновить</button>
              </div>
            )}
                    </div>
                </DateProvider>                  
        </AuthProvider>
    </ProjectProvider>

    
  );
}

export default App;
